import * as tslib_1 from "tslib";
import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators/take';
import { ObjectWithLinks, RelationTypes } from '../../common';
import { ApiTableService } from '../api-table/api-table.service';
import { ApiItemAddDialogComponent } from './dialog/api-item-add-dialog.component';
var ExtendzApiSelectComponent = /** @class */ (function () {
    function ExtendzApiSelectComponent(dialog, apiTableService) {
        this.dialog = dialog;
        this.apiTableService = apiTableService;
        this.itemChange = new EventEmitter();
        /**
         * Dissabled state
         */
        this.disabled = true;
        /**
         * When selected with the dialog box the first element response it taken to consideration.
         */
        this.response = null;
        /**
         * Display value for the current value.
         * Seperation is needed since the acctual selected value is an URL and the display values is a human readble text.
         */
        this.displayValue = '';
        /**
         * Empty array to contain the quick add items
         */
        this.qItems = [1];
        /**
         * Quick add shows or not
         */
        this.quickAdd = false;
        /**
         * On Change the selected form value
         */
        this.onChange = function () { };
        /**
         *On Touch the api selector
         */
        this.onTouched = function () { };
    }
    ExtendzApiSelectComponent_1 = ExtendzApiSelectComponent;
    ExtendzApiSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.all$ = this.apiTableService.getModel(this.property.reference).subscribe(function (meta) {
            _this.modelMeta = meta;
            _this.disabled = false;
        }, function (error) {
            //console.log(error.status);
        });
    }; // ngOnInit()
    ExtendzApiSelectComponent.prototype.ngOnDestroy = function () {
        if (this.all$)
            this.all$.unsubscribe();
    }; // ngOnDestroy()
    /**
     * Show a selection dialog.
     *
     * @param property Selected Property
     */
    ExtendzApiSelectComponent.prototype.openDialog = function (property) {
        var _this = this;
        var data = {
            property: property,
            response: []
        };
        if (this.response) {
            data.response = data.response.concat(this.response);
        }
        var dialogRef = this.dialog.open(ApiItemAddDialogComponent, {
            minWidth: '100vw',
            data: data
        });
        dialogRef.afterClosed().subscribe(function (result) {
            /**
             * Selected items will be send as an array. Even with for single selection.
             */
            if (_this.property.relationShipType === RelationTypes.MULTIPLE) {
                _this.handleDialogMultipleSection(result);
            }
            else {
                _this.getResponse(result[0]);
            }
        });
    }; // openDialog()
    ExtendzApiSelectComponent.prototype.handleDialogMultipleSection = function (results) {
        var _this = this;
        if (!results)
            return;
        // Get a display value
        var res = this.apiTableService
            .getItem(results[0])
            .pipe(take(1))
            .subscribe(function (response) {
            _this.response = [response];
            _this.value = results;
            if (_this.modelMeta.title) {
                var str = response[_this.modelMeta.title];
                _this.displayValue = str;
                if (results.length > 1) {
                    _this.setMultipleDisplay(results.length);
                }
            }
            res.unsubscribe();
        });
    }; // handleDialogMultipleSection()
    ExtendzApiSelectComponent.prototype.getItem = function (url) {
        return this.apiTableService.getItem(url).pipe(take(1));
    };
    /**
     * On quick save event is fired
     * @param item
     */
    ExtendzApiSelectComponent.prototype.onSave = function (item) {
        if (this.property.relationShipType === RelationTypes.MULTIPLE) {
            this.handleMultipleResponse([item]);
        }
        else {
            this.handleSingleResponse(item);
        }
    }; // onSave()
    ExtendzApiSelectComponent.prototype.getResponse = function (url) {
        var _this = this;
        var res = this.apiTableService
            .getItem(url)
            .pipe(take(1))
            .subscribe(function (response) {
            var tableResponse = response;
            // One to Many relationship
            if (tableResponse._embedded) {
                var key = Object.keys(tableResponse._embedded)[0];
                _this.handleMultipleResponse(tableResponse._embedded[key]);
            }
            else {
                var singleResponse = response;
                _this.handleSingleResponse(singleResponse);
            }
        }, function (error) {
            _this.response = undefined;
            _this.value = null;
        });
    }; // getResponse()
    ExtendzApiSelectComponent.prototype.handleMultipleResponse = function (data) {
        if (this.response)
            this.response = this.response.concat(data);
        else
            this.response = data.slice();
        // Map the self link
        this.value = this.response.map(function (d) { return d._links.self.href; });
        if (this.response.length !== 0) {
            var firstItem = this.response[0];
            if (this.modelMeta.title) {
                var str = firstItem[this.modelMeta.title];
                this.displayValue = str;
                if (this.response.length) {
                    this.setMultipleDisplay(this.response.length);
                }
            }
        }
    }; // handleMultipleResponse()
    ExtendzApiSelectComponent.prototype.setMultipleDisplay = function (more) {
        if (more >= 2)
            this.displayValue = this.displayValue + ' and ' + (more - 1) + ' more.';
    };
    ExtendzApiSelectComponent.prototype.handleSingleResponse = function (response) {
        this.response = [response];
        this.value = response._links.self.href;
        var item = response;
        //this.response = response;
        if (this.modelMeta.title) {
            this.displayValue = item[this.modelMeta.title];
        }
        else {
            this.displayValue = response._links.self.href;
        }
    }; // handleSingleResponse()
    Object.defineProperty(ExtendzApiSelectComponent.prototype, "value", {
        get: function () {
            return this.items;
        },
        set: function (val) {
            // If the value changed then get the reponse.Otherwise there will be a loop
            if (this.response === null)
                this.getResponse(val);
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    ExtendzApiSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ExtendzApiSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ExtendzApiSelectComponent.prototype.writeValue = function (value) {
        if (value) {
            this.value = value;
        }
    }; // writeValue()
    ExtendzApiSelectComponent.prototype.setDisabledState = function (isDisabled) { };
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", Object)
    ], ExtendzApiSelectComponent.prototype, "property", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", ObjectWithLinks)
    ], ExtendzApiSelectComponent.prototype, "item", void 0);
    tslib_1.__decorate([
        Output(),
        tslib_1.__metadata("design:type", EventEmitter)
    ], ExtendzApiSelectComponent.prototype, "itemChange", void 0);
    ExtendzApiSelectComponent = ExtendzApiSelectComponent_1 = tslib_1.__decorate([
        Component({
            selector: 'ext-api-select',
            template: "<div fxLayout=\"column\"> <mat-form-field fxFlex> <input matInput [placeholder]=\"property.name | camelCase\" [value]=\"displayValue\" [disabled]=\"disabled\"> <button *ngIf=\"item?._links\" matSuffix mat-icon-button (click)=\"quickAdd = !quickAdd\" [disabled]=\"disabled\"> <mat-icon> <svg *ngIf=\"!quickAdd\" id=\"add\" viewBox=\"0 0 24 24\"> <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> <svg *ngIf=\"quickAdd\" id=\"remove\" viewBox=\"0 0 24 24\"> <path d=\"M19 13H5v-2h14v2z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> <button matSuffix mat-icon-button (click)=\"openDialog(property)\" [disabled]=\"disabled\"> <mat-icon> <svg id=\"open_in_new\" viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z\" /> </svg> </mat-icon> </button> </mat-form-field> <mat-card class=\"mat-elevation-z1\" style=\"margin-bottom: 1vh\" *ngIf=\"quickAdd\"> <mat-card-content> <ext-api-item-basic *ngFor=\"let qItem of qItems\" [modelMeta]=\"modelMeta\" [item]=\"item\" [property]=\"property\" (save)=\"onSave($event)\"> </ext-api-item-basic> </mat-card-content> <mat-card-actions *ngIf=\"property.relationShipType === 'MULTIPLE'\" (click)=\"qItems.push(1)\"> <button mat-icon-button> <mat-icon> <svg id=\"add\" viewBox=\"0 0 24 24\"> <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> </mat-card-actions> </mat-card> </div>",
            styles: [" /*# sourceMappingURL=extendz-api-select.component.css.map */ "],
            providers: [
                {
                    provide: NG_VALUE_ACCESSOR,
                    multi: true,
                    useExisting: forwardRef(function () { return ExtendzApiSelectComponent_1; })
                }
            ]
        }),
        tslib_1.__metadata("design:paramtypes", [MatDialog, ApiTableService])
    ], ExtendzApiSelectComponent);
    return ExtendzApiSelectComponent;
    var ExtendzApiSelectComponent_1;
}());
export { ExtendzApiSelectComponent };
//# sourceMappingURL=extendz-api-select.component.js.map